import { takeLatest, put, select, all, call } from 'redux-saga/effects';
import { message } from 'antd';
import { removeDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';
import { toggleRemovePopupVisible } from '@store/dashboards/ui/actions';
import { getList } from '@store/dashboards/list/actions';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { parseDashboardURL } from '@utils';
import * as actions from './actions';
import * as tabsActions from '../tabs/actions';
import * as types from './types';

import tabsStoreSelector from '../tabs/selectors';
import { homePagePath } from '../../../routers/utils';
import { globalRouter } from '@src/utils/globalRouter';

let removeDashboardId = null;
function* defaultAfterRequest() {
  const tabs = yield select(tabsStoreSelector);
  const { tabsData } = tabs;

  let { name } = tabsData[removeDashboardId] || {};

  name = name || removeDashboardId;

  yield all([
    put(
      tabsActions.triggerRemoveTab(
        removeDashboardId,
        `Dashboard "${name}" has been removed successfully`,
      ),
    ),
    globalRouter.navigate(parseDashboardURL({})),
  ]);
}

function* afterRemove() {
  yield put(getList());
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* removing({ id, afterRequest = null }) {
  const afterRequestCallback = afterRequest || defaultAfterRequest;
  yield actions.fetching();
  try {
    removeDashboardId = id;
    yield autoRequest(removeDashboard, types.SCOPE, id, afterRequestCallback);
  } catch (error) {
    message.error(error.message);
  }
}

function* removeById({ id }) {
  yield put(actions.fetching());
  try {
    yield autoRequest(removeDashboard, types.SCOPE, id, afterRemove);
    yield put(tempDashboardActions.remove(id, true));
    yield put(toggleRemovePopupVisible());
    yield call(message.success, 'Successfully Delete!', 0.5);
    globalRouter.navigate(homePagePath, { replace: true });
  } catch (error) {
    message.error(error.message);
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchRemoving() {
  yield takeLatest([types.REMOVE_DASHBOARD], removing);
}

function* watchRemoveById() {
  yield takeLatest([types.REMOVE_DASHBOARD_BY_ID], removeById);
}

export default [watchInitRequest, watchRemoving, watchRemoveById];
